   // Footer.js
import React from 'react'; // Make sure React is imported
import './Footer.css'; // Assuming you have a CSS file for your footer styles
import FooterLogo from '../images/Solalogo.png'; // Make sure the path to your logo is correct

function Footer() { // Define your component as a function
    return (
        // --- NEW: Footer Section ---
        <footer className="footer-section">
            <div className="footer-content-wrapper">
                <div className="footer-logo-and-copyright">
                    {/* Assuming your logo is part of image_1831c3.png or a separate asset */}
                    <img src={FooterLogo} alt="Solaris Inc. Logo" className="footer-logo" />
                    <p className="footer-copyright">© 2025 Raysol Solar Tech Private Limited, Inc. <br/> All rights reserved.</p>
                </div>
                <div className="footer-links-column">
                    <h4 className="footer-column-heading">Quick Links</h4>
                    <ul>
                        <li><a href="#home">Home</a></li>
                        <li><a href="#about">About</a></li>
                        <li><a href="#products">Products</a></li>
                        <li><a href="#contact">Contact</a></li>
                    </ul>
                </div>
                <div className="footer-links-column">
                    <h4 className="footer-column-heading">Our Services</h4>
                    <ul>
                        <li><a href="#residential">Residential</a></li>
                        <li><a href="#commercial">Commercial</a></li>
                        <li><a href="#consulting">Consulting</a></li>
                        <li><a href="#maintenance">Maintenance</a></li>
                    </ul>
                </div>
                <div className="footer-links-column">
                    <h4 className="footer-column-heading">Company</h4>
                    <ul>
                        <li><a href="#team">Team</a></li>
                        <li><a href="#careers">Careers</a></li>
                        <li><a href="#blog">Blog</a></li>
                        <li><a href="#privacy">Privacy</a></li>
                    </ul>
                </div>
            </div>
        </footer>
        // --- End of NEW: Footer Section ---
    );
}

export default Footer; // <--- This is essential for it to be recognized as a component